<template>
  <div class="c-image">
    <div class="c-thumb">
      <div :class="classes">
        <div :class="uploadClass">
          <div class="c-upload-btns">
            <el-button @click.native="pickUpload" type="primary"> {{ btnText }} </el-button>
            <el-upload v-if="local" :before-upload="preUpload" :show-file-list="false" action="">
              <el-button type="default">本地上传</el-button>
            </el-upload>
          </div>
          <div class="c-upload-txt">
            <span>{{ description }}规格：{{ width }}x{{ height }}</span>
            <span>{{ description }}大小：{{ size | smartSize }}</span>
            <span>支持类型：{{ format | formatType }}</span>
          </div>
        </div>
        <!-- 图片地址 -->
        <img v-if="image" :src="url" :class="{ 'm-vertical-img': vertical }" :style="setWrapperWidth" alt="" />
      </div>
    </div>
    <div v-if="msg" class="c-col-msg">
      <span>{{ msg }}</span>
    </div>
  </div>
</template>
<script>
import { isArray } from '@/common/js/utils'
import mixins from './mixins'
import mixinVerify from './mixin-verify'
import { uploadMeterialCreative } from '@/api/kuaishou.model'
export default {
  name: 'CImage',
  mixins: [mixins, mixinVerify],
  props: {
    value: {
      type: [String, Number],
      required: true
    },
    name: {
      type: String,
      required: true
    },
    mode: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    width: {
      type: [Number, String],
      default: 0
    },
    height: {
      type: [Number, String],
      default: 0
    },
    size: {
      type: Number,
      default: 1024
    },
    format: {
      type: Array,
      default() {
        return ['jpeg', 'png']
      }
    },
    required: {
      type: Boolean,
      default: false
    },
    verify: {
      type: Boolean,
      required: true
    },
    source: {
      type: Array,
      required: true
    },
    sceneId: {
      type: Number,
      default: 1
    },
    loading: {
      type: Boolean,
      default: false
    },
    local: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    image: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    classes() {
      return ['c-thumb-wrapper', { 'm-default-bg': !this.image }]
    },
    uploadClass() {
      return ['c-alt-upload', { 'c-hide-upload': Boolean(this.image) }]
    },
    vertical() {
      return parseInt(this.height) >= parseInt(this.width)
    },
    // 根据比例自动缩放
    setWrapperWidth() {
      return parseInt(this.width) > 540 ? { width: `${(148 * parseInt(this.width)) / parseInt(this.height)}px` } : {}
    },
    btnText() {
      return this.image ? `更新${this.description}` : `选择${this.description}`
    },
    url() {
      let imageUrl = ''
      if (this.image) {
        const item = this.source.filter((ret) => ret.image_token === this.image).pop()
        if (item && item.url) imageUrl = item.url
      }
      return imageUrl
    }
  },
  methods: {
    pickUpload() {
      this.$emit('select', {
        imageId: this.value,
        name: this.name,
        type: this.mode,
        width: parseInt(this.width),
        height: parseInt(this.height),
        size: this.size
      })
    },
    uploadFile(file) {
      let mode = 'CREATIVE_MODE_IMAGE'
      if (this.name === 'cover' && this.vertical) {
        mode = 'CREATIVE_MODE_VIDEO_VERTICAL'
      } else if (this.name === 'cover') mode = 'CREATIVE_MODE_VIDEO'
      const params = {
        ad_account_id: this.$route.query.id,
        source_type: 1,
        media_id: 32,
        scene_id: this.sceneId,
        image_mode: mode,
        file
      }
      this.setLoading(true)
      uploadMeterialCreative(params)
        .then((data) => {
          this.setLoading(false)
          if (data && data.data) {
            data = data.data
            if (isArray(data)) {
              const item = data.pop()
              item && this.$emit('upload', { file: item, element: this.mode })
            }
          }
        })
        .catch((err) => {
          this.setLoading(false)
          console.error(err)
        })
    },
    setLoading(flag) {
      this.$emit('set-loading', flag)
    }
  }
}
</script>
<style lang='scss' scoped>
.c-image {
  position: relative;
  z-index: 5;
  height: 148px;
  min-width: 260px;
  display: inline-block;
  padding-bottom: 12px;

  .c-thumb {
    width: 100%;
    height: 100%;

    .m-default-bg {
      height: inherit;
      background-color: #e8e8e8;
    }

    .c-thumb-wrapper {
      width: 100%;
      height: 100%;
      position: relative;
      z-index: 9;
      overflow: hidden;
      background-color: #efefef;

      .c-fix-loading {
        position: absolute;
        width: 100%;
        height: 100%;

        ::v-deep .ant-spin-container {
          width: inherit;
          height: inherit;
        }
      }

      img {
        width: 100%;
        height: 100%;
        display: block;
        background-color: #e8e8e8;

        &.m-vertical-img {
          margin: 0 auto;
        }
      }
    }

    .c-alt-upload {
      width: 100%;
      height: 100%;
      padding: 0 12px;
      position: absolute;
      z-index: 7;
      top: 0;
      left: 0;
      text-align: center;

      .c-upload-btns {
        padding: 22px 0 12px;
        display: flex;
        justify-content: center;

        button {
          margin-right: 10px;
        }
      }

      .c-upload-txt {
        padding: 6px 12px;

        span {
          display: block;
          line-height: 1.4;
        }
      }
    }

    .c-hide-upload {
      opacity: 0;

      &:hover {
        opacity: 1;
        background-color: rgba(0, 0, 0, 0.6);

        .c-upload-txt {
          color: #fff;
        }
      }
    }
  }

  .c-col-msg {
    position: absolute;
    z-index: 4;
    left: 0;
    bottom: -4px;
    color: #ff4400;
  }
}
</style>
